<!--
  # sidebar-item

  Conditionally renders one of 3 components based on the type of item it receives:

  1. sidebar-group
  2. sidebar-link
  3. s-divider
 -->
<template>
  <sidebar-group
    v-if="item.type === 'group'"
    :subtext="item.subtext"
    :icon="item.icon"
    :prefix="item.prefix"
    :links="item.links"
    v-bind="$attrs"
  >
    {{ item.label }}
  </sidebar-group>
  <sidebar-link
    v-if="item.type === 'link'"
    :href="item.href"
    :external="item.external"
    :icon="item.icon"
    :active-pattern="item.activePattern"
    :active-params="item.activeParams"
    :active-prefix="item.activePrefix"
    v-bind="$attrs"
    :aria-label="item.ariaLabel"
  >
    {{ item.label }}
  </sidebar-link>
  <hr
    v-if="item.type === 'divider'"
    class="relative w-full border-t border-blue-400/40 -l-3 r-0 my-3"
    v-bind="$attrs"
  />
</template>
<script setup lang="ts">
import {SidebarItem as SidebarItemData} from './types';
import SidebarGroup from './SidebarGroup.vue';
import SidebarLink from './SidebarLink.vue';

defineProps<{item: SidebarItemData}>();
</script>
